import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Container from "./Container.jsx";
import axios from "axios";
import PricePeriods from "../components/Views/PricePeriods.jsx";

class SubscriptionContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("price_periods");
        this.state = {
            ...this.state,
            loading: true,
        };
    }

    componentDidMount = async () => {
        await this.getAuxData();
    };

    getAll = (params = {}) => {
        const path = this.datasource.dataPath + "/" + this.modelName;

        return axios.get(path, { params }).then((response) => response.data);
    };

    setCustomLoading = (loading) =>
        this.setState((state) => ({ ...state, loading: loading }));

    render = () => {
        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();

        const auxDataRates = this.props?.auxData && this.props.auxData?.rates;

        if (this.state.error && this.state.error.status == 403) {
            return <Route render={() => <Redirect to="/hotels" replace />} />;
        }

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <PricePeriods
                        title={"Периоды цен"}
                        getAllItems={this.getAllItems}
                        barPrices={this.state.AllItems}
                        editAction={this.getEditLink}
                        fields={fields}
                        paramsChangeHandler={this.paramsChangeHandler}
                        hotelId={this.props.match.params.mainId}
                        setLoading={this.setCustomLoading}
                        rates={auxDataRates}
                        loading={this.state.loading}
                    />
                </Route>
            </Switch>
        );
    };
}

export default SubscriptionContainer;
